import {
  ActionIcon,
  Box,
  CloseButton,
  Group,
  Loader,
  NumberInput,
  StyleProp,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { IconCheck } from "@tabler/icons-react";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { EditProps } from "./util";
interface NumberEditProps extends EditProps {
  max?: number;
  min?: number;
  precision?: number;
  icon?: React.ReactNode;
  rightSection?: React.ReactNode;
  w?: StyleProp<React.CSSProperties["width"]>;
}
const NumberProp = ({
  object,
  prop,
  mutate,
  label,
  max,
  placeholder,
  fullWidth,
  min,
  precision,
  className,
  icon,
  disabled,
  w,
}: NumberEditProps) => {
  const { t } = useTranslation();
  const current = (object[prop] as string) || "";
  const [saving, setSaving] = useState(false);
  // const [val, setVal] = useState<number | undefined>();
  const form = useForm({
    initialValues: {
      value: current,
    },
  });
  const doSave = (value: string) => {
    // console.log("doSave :", value);
    // object[prop] = value;
    const dto: any = {
      _id: object._id,
    };
    dto[prop] = value;
    setSaving(true);
    mutate(dto, {
      onSuccess: () => {
        form.reset();
        form.setValues({ value });
        setSaving(false);
        showNotification({
          message: t("Saved"),
          autoClose: true,
          color: "success",
        });
      },
    });
  };
  const cancel = () => {
    // console.log("cancel");
    form.reset();
    form.setValues({ value: current });
  };
  const edited = form.values.value !== current;
  // console.log("current :", current);
  // console.log("form.values.value :", form.values.value);
  const getRightSection = () => {
    if (saving) return <Loader size="xs" />;
    if (edited)
      return (
        <Group wrap="nowrap">
          <ActionIcon type="submit" variant="transparent">
            <IconCheck size={16} />
          </ActionIcon>
          <CloseButton onClick={cancel} size="xs" />
        </Group>
      );
  };
  useEffect(() => {
    if (object[prop] === form.values.value) return;
    if (!object[prop]) return;
    form.setValues({ value: object[prop] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [object]);
  // const onInputSubmit = (e: React.KeyboardEvent<HTMLInputElement>) => {
  //   console.log("onInputSubmit :", value);
  //   if (e.key === "Enter") {
  //     // onSubmit(e);
  //   }
  // };
  // console.log("w :", w);
  return (
    <Box w={w}>
      <form
        onSubmit={form.onSubmit((values) => doSave(values.value))}
        className={className}
      >
        <NumberInput
          rightSectionWidth={84}
          max={max}
          min={min}
          leftSection={icon}
          decimalScale={precision}
          disabled={disabled}
          placeholder={placeholder || label}
          label={label}
          // value={val}
          // onChange={(val) => {
          //   setVal(val === "" ? undefined : val);
          // }}
          // removeTrailingZeros={true}
          hideControls
          {...form.getInputProps("value")}
          w={fullWidth ? "100%" : "auto"}
          rightSection={getRightSection()}
        />
      </form>
    </Box>
  );
};
export default NumberProp;
